// extracted by mini-css-extract-plugin
module.exports = {"service":"Service_service__3nRIw","serviceImg":"Service_serviceImg__1AAAT","serviceDesc":"Service_serviceDesc__9S7_d"};